import Form from '../../common/form';
import Joi from 'joi';

import { func } from 'prop-types';
import { getResultOptions } from '../../../utils/data';

class LPTReportItemForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		joint: Joi.string().min(3).required().label('Joint/Job Number'),
		observation: Joi.string().min(10).required().label('Observation'),
		result: Joi.string().min(3).required().label('Result'),
		images: Joi.array().min(1).required().label('Image'),
	};

	static propTypes = {
		onAdd: func,
	};

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<h3 className="form-title">Inspected Item(s)</h3>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'joint',
							label: 'Joint/Job Number',
							placeholder: 'Enter Joint/Job Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'observation',
							label: 'Observation',
							placeholder: 'Enter your Observation',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'result',
							label: 'Result.',
							placeholder: 'Select Result',
							options: getResultOptions(),
						})}
					</div>

					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.props.photoNumbers,
							name: 'images',
							placeholder: 'Select Photo Number',
							label: 'Photo Number',
							isMulti: true,
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				{this.renderButton('Add Row')}
			</form>
		);
	}
}

const initialData = {
	joint: '',
	observation: '',
	result: '',
	images: [],
};

export default LPTReportItemForm;
